import styled from "styled-components";

export const ContainerEditarListas = styled.div`
  .filtros-lista{
    display: flex;
    justify-content: flex-start;
    .select-filtro-listas{
      width: 40%;
    }
  }
  .linha-pai {
    display: flex;
    justify-content: center;
    .linha {
      margin: 4rem 0;
      height: 2px;
      background-color: ${(props) => props.theme.colors.elements};
      width: 40%;
    }
  }
  .nova-tabela {
    text-align: center;
    color: ${(props) => props.theme.colors.primary};
    margin-bottom: 4rem;
    span {
      cursor: pointer;
    }
  }

  .tableContainer{
    >table{
      >thead{
        >tr{
          >th{
            .th-wrapper{
              padding: 2rem;
            }
          }
        }
      }
    }
  }

  .editar {
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    
    &:hover {
      text-decoration: underline;
    }
  }

  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const Lista = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
`;

export const TituloLista = styled.div`
  flex: 1;
  text-align: center;
  .center {
    display: flex;
    justify-content: center;
  }
  span{
    cursor: pointer;
  }
`;

export const Botoes = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;

  .cancelar {
    color: ${(props) => props.theme.colors.tertiary};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    svg {
      fill: ${(props) => props.theme.colors.primary};
      transform: rotate(90deg);
    }
  }
`;

export const CriarCategoriaContainer = styled.div`
  &.hidden {
    display: none;
  }

  .inputs_nome_moeda {
    display: grid;
    grid-template-columns: 65% 35%;
    grid-gap: 10px;
  }

  .tabela {
    margin: 25px 0;
  }

  .ajustes {
    display: grid;
    grid-template-columns: 50% 50%;
    margin-bottom: 25px;
  }

  .texto {
    text-align: center;
    color: ${(props) => props.theme.colors.tertiary};
    margin-bottom: 5rem;
  }

  .toggle {
    display: flex;
    margin: 15px 0;
    align-items: center;

    .info {
      margin-left: 10px;
      color: ${(props) => props.theme.colors.tertiary};
    }
  }
`;
